import React from 'react';
import './DownloadButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';

class DownloadButton extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true};
    }

    handleClick(url, filename) {
        if (this.props.link) {
            // Öffne die angegebene URL in einem neuen Tab
            window.open(this.props.link, '_blank', 'noopener,noreferrer');
        } else if (SystemConfiguration.mesh_name) {
            // Führe den Download aus
            axios.get(url, {
                responseType: 'blob',
            })
            .then((res) => {
                fileDownload(res.data, filename);
            });
        }
      }

    render() {
        return (
            <div id={this.props.id} className="downloadbutton" onClick={() => this.handleClick(SystemConfiguration.zip_file, SystemConfiguration.mesh_name + ".zip")}>{this.props.children}</div>
        );
    }
}

export default DownloadButton;